import { Component } from '@angular/core';
import { ApplicationFiltersModel } from '../../../../core/models/patient/application-filters.model';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { SurveyService } from '../../../../core/services/survey/survey.service';
import { SurveyPage } from '../../../../core/models/survey/survey-list.model';
import { AnswerTypeUtils } from '../../../../utils/answer-type-utils';
import { ToastService } from '../../../../core/services/toast.service';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
@Component({
  selector: 'app-survey-list',
  standalone: true,
  imports: [CommonModule, RouterModule, TranslateModule],
  templateUrl: './survey-list.component.html',
  styleUrl: './survey-list.component.scss',
})
export class SurveyListComponent {
  surveyListLoading: boolean = true;
  applications: ApplicationFiltersModel[] = [
    {
      id: 1,
      title: this.translate.instant('dermatology'),
      code: 'DERM',
    },
    {
      id: 2,
      title: this.translate.instant('osas'),
      code: 'OSAS',
    },
    {
      id: 3,
      title: this.translate.instant('diabetes'),
      code: 'DIAB',
    },
  ];
  selectedApplicationCode: string = 'DERM';
  surveys: SurveyPage[] = [];
  deleteModalId: string = '';

  constructor(
    private surveyService: SurveyService,
    private toastService: ToastService,
    private translate: TranslateService
  ) {}

  ngOnInit(): void {
    this.getSurveyList(this.selectedApplicationCode);
  }

  selectApplicationFilter(code: string): void {
    this.selectedApplicationCode = code;
    this.getSurveyList(this.selectedApplicationCode);
  }

  getSurveyList(code: string): void {
    this.surveyService.surveyList(code).subscribe({
      next: (res) => {
        this.surveys = res;
      },
      complete: () => {
        this.surveyListLoading = false;
      },
    });
  }

  getAnswerType(status: number): string {
    const answerType = AnswerTypeUtils.getAnswerType(status);
    return answerType ? answerType.name : 'Unknown';
  }

  deleteQuestion(id: string): void {
    this.surveyService.deleteQuestion(id).subscribe({
      next: () => {
        this.toastService.showToast('Question has been deleted.', 'success');
        this.getSurveyList(this.selectedApplicationCode);
      },
    });
  }
}
